import React, { FC } from 'react';
import { Image } from 'react-bootstrap';
import { User } from '../../../../api/src/interfaces/shared';

interface Props {
  member: User;
  onMemberClick: () => void;
}

const MemberRow: FC<Props> = ({ member, onMemberClick }) => (
  <tr className="mouse-pointer" onClick={onMemberClick}>
    <td>
      <Image
        src={`https://graph.facebook.com/v2.8/${member.facebookId}/picture?type=square`}
        style={{ maxWidth: '50px', maxHeight: '50px' }}
        roundedCircle
      />
    </td>
    <td>{member.name}</td>
  </tr>
);

export default MemberRow;
